import { NetworkId } from '../global';
import { ApiResponseDto } from './api-response.dto';
import { AqiStandardV1Dto, AqiStandardId, AqiStandardV2Dto } from './aqi-standard.dto';
import { PollutantConfigDto } from './pollutant-config.dto';
import { DistanceUnitSystem } from '../distance';
import { Pollutant } from '../pollutant';

export enum DatasourceDetailsSection {
  HEALTH_RECOMMENDATIONS = 'HEALTH_RECOMMENDATIONS',
  EQUIPMENT = 'EQUIPMENT',
  TREND = 'TREND',
  LOCATION = 'LOCATION',
  CURRENT = 'CURRENT',
  DOWNLOAD = 'DOWNLOAD',
}

export class NetworkV1Dto {
  networkId: NetworkId;
  name: string;
  logoUrl: string;
  networkUrl: string | null;
  datasourceDetailsSections: DatasourceDetailsSection[];
  visible: boolean;

  /**
   * Available pollutants and their corresponding metrics
   */
  pollutantConfigs: PollutantConfigDto[];

  aqiStandardId: AqiStandardId;
  distanceUnitSystem: DistanceUnitSystem;
  isNotificationEnabled: boolean;
}

export class NetworkV2Dto {
  networkId: NetworkId;
  name: string;
  logoUrl: string;
  networkUrl: string | null;
  datasourceDetailsSections: DatasourceDetailsSection[];
  visible: boolean;
  enabledPollutants: Pollutant[];
  distanceUnitSystem: DistanceUnitSystem;
  isNotificationEnabled: boolean;
}

export class NetworkSummaryDto {
  networkId: NetworkId;
  name: string;
  logoUrl: string;
  visible: boolean;
}

export class GetNetworksResponseDto extends ApiResponseDto<{
  networks: NetworkSummaryDto[];
}> {
  declare data: {
    networks: NetworkSummaryDto[];
  };
  declare metadata: { timestamp: Date };
}

export class GetSingleNetworkV1ResponseDto extends ApiResponseDto<{
  network: NetworkV1Dto;
  aqiStandard: AqiStandardV1Dto;
}> {
  declare data: {
    network: NetworkV1Dto;
    aqiStandard: AqiStandardV1Dto;
  };
  declare metadata: { timestamp: Date };
}
export class GetSingleNetworkV2ResponseDto extends ApiResponseDto<{
  network: NetworkV2Dto;
  aqiStandards: AqiStandardV2Dto[];
}> {
  declare data: {
    network: NetworkV2Dto;
    aqiStandards: AqiStandardV2Dto[];
  };
  declare metadata: { timestamp: Date };
}
